// extracted by mini-css-extract-plugin
module.exports = {"eccComicsFooter":"FooterEccComics_eccComicsFooter__ORSAk","upperMenu":"FooterEccComics_upperMenu__0j6_z","lineBorder":"FooterEccComics_lineBorder__0zGs0"};